import { CashMemoCompany } from './cash-memo';

// Aziz Auto A1-A5: an invoice header kept in Settings > Invoices. Blank fields print the company.
export interface IInvoiceProfile {
  id: string;
  label: string;
  companyName?: string | null;
  companyEmail?: string | null;
  companyNumber?: string | null;
  companyWebsite?: string | null;
  companyBinNo?: string | null;
  companyVatNo?: string | null;
  address?: string | null;
  logoUrl?: string | null;
  isDefault: boolean;
}

// The company header with a sale's profile laid over it, merged by the API.
export interface IInvoiceHeader {
  companyName: string | null;
  companyEmail: string | null;
  companyNumber: string | null;
  companyWebsite: string | null;
  companyBinNo: string | null;
  companyVatNo: string | null;
  address: string | null;
  image: string | null;
}

// A new sale opens with the default profile selected.
export const chooseInitialInvoiceProfileId = (profiles: IInvoiceProfile[]): string | undefined =>
  profiles.find((profile) => profile.isDefault)?.id;

export const invoiceHeaderToReceiptCompany = (header: IInvoiceHeader): CashMemoCompany => ({
  name: header.companyName,
  number: header.companyNumber,
  address: header.address,
  tax: header.companyVatNo,
  bin: header.companyBinNo,
});
